"use client";

export default function Frameworks() {
  const frameworks = [
    {
      title: "The 4-step Prompt formula",
      icon: "/images/af1.svg", 
    },
    {
      title: "Mastering Market Analysis",
      icon: "/images/af2.svg", 
    },
    {
      title: "Redefining Content Creation",
      icon: "/images/af3.svg", 
    },
    {
      title: "Data Analytics Made Easy",
      icon: "/images/af4.svg", 
    },
    {
      title: "Transform Your Presentations",
      icon: "/images/af5.svg", 
    },
    {
      title: "Adapting to AI Trends",
      icon: "/images/af6.svg", 
    },
    {
      title: "Unlock Career Opportunities",
      icon: "/images/af7.svg", 
    },
    {
      title: "Personal Branding",
      icon: "/images/af8.svg", 
    },
    {
      title: "AI tools for Productivity",
      icon: "/images/af9.svg", 
    },
  ];

  return (
    <section className="w-full py-6 md:py-12">
      <div className="w-[90%] md:w-[80%] mx-auto">
        {/* Header Section */}
        <div className="mb-8 text-left">
          <p className="text-[#0A0A0A] text-sm md:text-base font-normal uppercase mb-2">
            FRAMEWORKS
          </p>
          <h2 className="text-[#002726] text-[28px] md:text-[32px] font-medium mb-3 w-full md:w-[80%]">
            Learn AI Frameworks & Strategies For 10X Productivity
          </h2>
        </div>

        {/* Frameworks Grid - 3 columns for both desktop and mobile */}
        <div className="grid grid-cols-3 gap-4 md:gap-6">
          {frameworks.map((framework, index) => (
            <div
              key={index}
              className="rounded-xl p-4 border border-[#818490] text-left"
              style={{ backgroundColor: "#FFFAF1" }}
            >
              {/* SVG Icon Placeholder */}
              {framework.icon ? (
                <div className="mb-3 w-8 h-8">
                  <img
                    src={framework.icon}
                    alt={framework.title}
                    className="w-8 h-8 object-contain"
                  />
                </div>
              ) : (
                <div className="mb-3 w-8 h-8">
                  <svg
                    className="w-8 h-8 text-[#0A0A0A]"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    {/* Empty placeholder - user will replace */}
                  </svg>
                </div>
              )}
              <h3 className="text-[#002726] text-sm md:text-base font-normal">
                {framework.title}
              </h3>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
